module.exports = __webpack_public_path__ + "media/images/menu-queries-icon-0f54e632e05b2483ee1c55cdbdb7644c.svg";